import { RootState } from '../../Store';
import { useSelector } from 'react-redux';
import moment from 'moment';

export const useGetMomentResultsAreFetched = (): moment.Moment | undefined =>
    useSelector<RootState, moment.Moment | undefined>(state => state.filter.fetchedAt);
